/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type IntegrationResource = {
    /**
     * The ID of the integration.
     */
    id: number
    /**
     * The sort order of the integration.
     */
    sort?: number | null
    /**
     * The name of the integration.
     */
    name: string
    /**
     * The display name of the integration.
     */
    display_name: string
    /**
     * The description of the integration.
     */
    description: string
    status: IntegrationResource.status | null
    /**
     * Whether or not the integration is enabled.
     */
    builder_io_id: string | null
    /**
     * The tithe.ly product code of the integration.
     */
    product_code: string | null
    /**
     * The tithe.ly offer code of the integration. If null, defaults to product code.
     */
    offer_code: string | null
    /**
     * The category of the integration. Used by the UI to group integrations.
     */
    category: string
    /**
     * The short name of the integration. Used by some UI elements.
     */
    short_name: string | null
    /**
     * The URL of the third party app that this integration is for.
     */
    third_party_url: string | null
    /**
     * The icon used in the corner of the integration's card.
     */
    icon?: string | null
    /**
     * The permissions that should be granted when enabling the integration.
     */
    permissions?: Record<string, Array<string>> | null
}

export namespace IntegrationResource {
    export enum status {
        '_0' = 0,
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
        '_4' = 4,
        '_5' = 5,
        '_6' = 6
    }
}
